'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthenticationPolicySection } from '@/features/identity-policy';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings/authentication-method/')({
  component: AuthenticationMethodSettingsPage
});
function AuthenticationMethodSettingsPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.settings.authentication.settings.authenticationMethod'
  });
  return <AuthenticationPolicySection title={t('title')} description={t('description')} />;
}